<template>
<div class="container" :class="fixedTop ?'fixedTop':''">
      <pageHeader/>
        <router-view :key="routerViewKey" />
      <pageFooter/>
    </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import pageHeader from '@/components/common/pageHeader'
  import pageFooter from '@/components/common/pageFooter'
  export default {
    name: 'sd-layout-header-footer',
    components: {
      pageHeader,
      pageFooter
    },
    data() {
      return {
        fixedTop:false,
      }
    },
    computed: {
      routerViewKey() {
        // 默认情况下 key 类似 __transition-n-/foo
        // 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
        const stamp = this.$route.meta[`__stamp-${this.$route.path}`] || ''
        return `${stamp ? `__stamp-${stamp}-` : ''}${this.$route.path}`
      },
    },
    mounted() {
      window.addEventListener('scroll',this.handleScroll,true);
      var tokens = this.$getCookie('sd_token');
      if(tokens != undefined){
        this.$store.commit('user/SET_LOGIN',true);
      }
    },
    methods: {
      handleScroll(){
       /* let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        if(scrollTop > 0){
          this.fixedTop = true;
        }else{
          this.fixedTop = false;
        }*/
      },
    }
  }
</script>

<style lang="less">
  .container{
    min-width: 1200px;
  }
  &.fixedTop{
    padding-top: 68px;
    .sd_header{
      position: fixed;
      top: 0px;
      left: 0px;
      box-shadow: 0px 0px 10px #9f9f9f;
    }
  }
</style>
